import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
    ResetData,
    SaveBranchState,
    SaveDataState,
    SaveFilter,
    SaveFilterState,
    SaveQueryState,
    SaveTotalReportState,
} from './main.actions';

export interface MainStateModel {
    filters: any;
    totalReportState: any;
    branchState: any;
    filterState: any;
    query: any;
    data: any;
}

@Injectable()
@State<MainStateModel>({
    name: 'main',
    defaults: {
        filters: null,
        totalReportState: null,
        branchState: null,
        filterState: null,
        query: null,
        data: null,
    },
})
export class MainState {
    constructor() {}

    @Selector()
    static getFilters(state: MainStateModel): any {
        return state.filters || null;
    }

    @Selector()
    static getData(state: MainStateModel) {
        return state.data;
    }
    @Action(SaveFilter)
    saveFilter(ctx: StateContext<MainStateModel>, { data }: SaveFilter): void {
        // ctx.patchState({
        //   token: data.login.token,
        //   refreshToken: data.login.refreshToken,
        //   user: data.login.user
        // });
    }

    @Action(SaveTotalReportState)
    saveTotalReportState(
        ctx: StateContext<MainStateModel>,
        { totalReportState }: SaveTotalReportState,
    ): void {
        ctx.patchState({
            totalReportState: totalReportState,
        });
    }

    @Action(SaveBranchState)
    saveBranchState(
        ctx: StateContext<MainStateModel>,
        { branchState }: SaveBranchState,
    ): void {
        ctx.patchState({
            branchState: branchState,
        });
    }

    @Action(SaveFilterState)
    saveFilterState(
        ctx: StateContext<MainStateModel>,
        { filterState }: SaveFilterState,
    ): void {
        ctx.patchState({
            filterState: filterState,
        });
    }

    @Action(SaveDataState)
    saveDataState(
        ctx: StateContext<MainStateModel>,
        { data }: SaveDataState,
    ): void {
        ctx.patchState({
            data: data,
        });
    }

    @Action(SaveQueryState)
    saveQueryState(
        ctx: StateContext<MainStateModel>,
        { query }: SaveQueryState,
    ): void {
        ctx.patchState({
            query: query,
        });
    }

    @Action(ResetData)
    resetData(ctx: StateContext<MainStateModel>, {}: ResetData): void {
        ctx.patchState({
            filters: null,
            totalReportState: null,
            filterState: null,
            query: null,
            data: null,
        });
    }
}
